// extracted by mini-css-extract-plugin
module.exports = {"root":"disclaimer_root__1s7tf","container":"disclaimer_container__2WR_C"};